import React, { Component } from 'react';
import { DashboardLayout } from '../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import StripeCheckout from 'react-stripe-checkout';
import { userActions } from '../../../common/redux/actions';
import ProfileVerified from '../Common/ProfileVerified';
import MemberShipDialog from './partials/MemberShipDialog';

class TutorMemberShip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stripeKey: process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY,
            memberships: null,
            item: null,
            loading: false,
            open: false,
        };
    }

    componentDidMount() {
        this.loadMemberShip();
    }

    loadMemberShip = () => {
        const { dispatch } = this.props;
        this.setState({ loading: true });
        itemService.membership("GET", null).then(data => {
            let items = data;
            const memberships = items.filter(val => val.id !== 1);
            this.setState({ memberships, loading: false });
        })
            .catch(exception => {
                gs.showErrors(exception, dispatch, alertSelectors);
                this.setState({ loading: false });
            });
    }

    onPayment = (token, plan_id, item) => {

        this.props.dispatch(userActions.membership("POST", { token: { id: token.id, email: token.email }, plan_id: item.id }, { plan_id: item.id }));
    };

    onCancel = (item) => {
        this.props.dispatch(userActions.membership("POST", { plan_id: 1 }, { plan_id: 1 }));
    };

    cancle = (item) => {
        return (<button className="btn btn-outline-primary" onClick={() => this.onCancel(item)}>Downgrade</button>);
    }

    openDialog = (item) => {
        console.log('item', item);
        this.setState({
            open: true,
            item: item
        });
    }

    render() {
        const { memberships, loading, open, item } = this.state;
        const { authentication } = this.props;
        const { userProfile } = authentication.authentication.user;

        let balance_sessions = userProfile && userProfile.balance_sessions > 0 ? userProfile.balance_sessions : 0;
        let monthly_balance_sessions = userProfile && userProfile.monthly_balance_sessions > 0 ? (userProfile.monthly_balance_sessions - balance_sessions) : 0;

        return (<DashboardLayout>
            <MemberShipDialog open={open} item={item} handleClose={() => this.setState({open: false})} />
            <section className="dashboard">

                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box d-flex justify-content-between">
                            <h2 className="mb-0 page-title">Membership</h2>
                            <ProfileVerified />
                        </div>
                    </div>
                </div>
                <div className="post-box">
                    <div className="sub-heading py-3">
                        <h3 className="text-center">Membership Plan</h3>
                    </div>
                    <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center mb-4 session-block">
                        <div className="sessions">
                            Current Plan Balance <span className="bg-primary text-white">{monthly_balance_sessions}</span>
                        </div>
                        <div className="sessions">
                            Adjusted Balance <span className="bg-secondary text-white">{userProfile && userProfile.balance_sessions}</span>
                        </div>
                        <div className="sessions">
                            Total Balance <span className="bg-success text-white">{userProfile && (userProfile.balance_sessions + monthly_balance_sessions)}</span>
                        </div>
                    </div>
                    <div className="col-lg-11 col-md-12 mx-auto">
                        <div className="row multi-color">
                            {loading ? <>
                                {[1, 2, 3].map((item) =>
                                    <div className="col-lg-4 col-md-9 mb-4" key={`bok-${item}`}>
                                        <div className={`membership-box h-100 blur other-${item}`}>
                                            <h6 className="text-center text-white">1 Month</h6>

                                            <h1 className="title"><sup>$</sup>24.95 <small>/ Month</small></h1>

                                            <div className="detail">
                                                <div className="list">
                                                    <p><i className="far fa-check-circle mr-2"></i>Provides 10 session</p>
                                                    <p><i className="far fa-check-circle mr-2"></i>Session Duration 60 Min</p>
                                                </div>
                                                <h5 className="text-center font-weight-bold py-4">Current Plan</h5>
                                                <div className="submit text-center mb-3">
                                                    <button className="btn btn-outline-primary">Downgrade</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </> : <>
                                    {memberships && memberships.map((item, index) =>
                                        <div className="col-lg-4 col-md-9 mb-4" key={item.id}>
                                            <div className={`membership-box h-100 other-${index + 1}`}>
                                                <h6 className="text-center text-white">{item.name} </h6>

                                                <h1 className="title"><sup>$</sup>{item.amount} <small>/ {item.name}</small></h1>

                                                <div className="detail">
                                                    <div className="list">
                                                        <p><i className="far fa-check-circle mr-2"></i> {item.description}</p>
                                                    </div>
                                                    <h5 className="text-center font-weight-bold py-4 text-primary">
                                                        {(userProfile && userProfile.plan_id === item.id) ? 'Current Plan' : ''}
                                                    </h5>
                                                    <div className="submit text-center mb-3">
                                                        {(userProfile && userProfile.plan_id === item.id) ? this.cancle(item) :
                                                            // <div className="btn btn-primary">
                                                            //     <StripeCheckout token={(token) => this.onPayment(token, item.plan_id, item)} stripeKey={this.state.stripeKey} amount={Number.parseFloat(item.amount) * 100} image={`${gs.rootUrl}/images/stripe_logo.png`} ComponentClass="div" label="Pay Now" panelLabel="Pay Now" allowRememberMe={false}>Select</StripeCheckout>
                                                            // </div>
                                                            <button type="button" className="btn btn-primary" onClick={() => this.openDialog(item)}>Select</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>}

                        </div>
                    </div>


                </div>
            </section>
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(TutorMemberShip);